<app-custom-modal (oncrossBtnClick)="Cancel()">
    <h4 header *ngIf="isQzLatestInstalled; else updateHeader">Warning!!</h4>
    <ng-template #updateHeader>
        <h4 header *ngIf="(!isDownloading && !downloadComplete) || isDownloading">
            <i class="fa-regular fa-arrows-rotate"></i> Update Available
        </h4>
    </ng-template>
    <h4 header *ngIf="downloadComplete && !isDownloading && fromMainScreen"><i class="fa-regular fa-arrows-rotate"></i> Update Complete</h4>
    <span body>
        <div class="row qz-steps" *ngIf="isQzLatestInstalled">
            <div class="col pt-3 px-4 ms-4">
                <div class="row mb-3">
                    <div class="col-11 ps-3">
                        <h2 class="text-danger">QZ-Tray has not been installed or is inactive on your machine.</h2>
                    </div>
                    <div class="col-1 text-end">
                        <app-user-guide-icon [ActiveTabId]= "'QzTrayInstallation'"></app-user-guide-icon>
                    </div>
                </div>
                <li class="qzTry-steps_1 list-unstyled fw-normal">To enable label printing, please ensure QZ-Tray is installed and running.</li>
                <div class="row">
                    <div class="col-8 mt-1 ps-4">
                        <li class="qzTry-steps_2 list-unstyled">Steps to set up and activate QZ-Tray:</li>
                        <ul class="qz-inner-text ms-4 mb-2">
                            <li class="pb-1">Download the latest version of QZ-Tray.
                                <a #QzDownloadLink class="d-none" [href]="qzUrlString">Click Here</a><a #JavaDownloadLink
                                class="d-none" [href]="javaUrlString">Click Here</a>
                                <button class="hotkey_primary" (click)="clickActions('FrmMain')">Click here</button>
                            </li>
                            <li>Open the downloaded file (from your Downloads folder or the browser download bar) and click to complete the installation</li>
                            <li>Once installed, launch QZ-Tray from your system.</li>
                            <li>Right-click the QZ-Tray icon in the system tray (bottom-right corner of your screen).</li>
                            <li>Ensure the <b>“Automatically Start”</b> option is enabled.</li>
                            <li>Close all browser windows and re-launch the application to apply changes.</li>
                        </ul>
                        <li class="qzTry-steps_3 list-unstyled">First-time printing setup:</li>
                        <ul class="qz-inner-text ms-4">
                            <li class="mt-2">When printing a label for the first time, a prompt will appear.</li>
                            <li>Select <b>“Remember Me”</b> and click <b>“OK”</b> to avoid seeing this prompt again.</li>
                        </ul>
                    </div>
                            <!-- <li> If not installed then
                            <a #QzDownloadLink style="display: none;" [href]="qzUrlString">Click Here</a><a #JavaDownloadLink style="display: none;" [href]="javaUrlString">Click Here</a>
                            <button class="hotkey_primary" (click)="clickActions(JavaDownloadLink,QzDownloadLink)" >Click here</button>
                            to Download and Install the <strong>latest</strong> version of Java and Qz-Tray and follow as below.</li> -->
                            <!-- <li>
                            Qz-Tray requires Java for Installation.So please install java first and then install Qz-Tray.
                            </li>
                            <li>Qz-Tray requires Java for Installation. When installing Qz-Tray, If Java is not installed on the application it would prompt to install the latest version of Java prior to Qz-Tray installation.
                            <a #JavaDownloadLink style="display: none;" [href]="javaUrlString">Click Here</a><button class="hotkey_primary" (click)="JavaDownloadLink.click()" >Click here</button>
                            to Download and Install the <strong>latest</strong> version of Java and follow as below.
                            </li>
                            <li><a #QzDownloadLink style="display: none;" [href]="qzUrlString">Click Here</a>
                            <button class="hotkey_primary" (click)="QzDownloadLink.click()" >Click here</button>
                            to Download and Install the <strong>latest</strong> version of Qz-Tray</li> -->
                            <!-- <div class="row">
                            <ul>
                                <p class="col-12">
                                    Qz-Tray requires Java for Installation. When installing Qz-Tray, If Java is not installed on the application it would prompt to install the latest version of Java prior to Qz-Tray installation. Please allow to install Java.
                                </p>
                            </ul>
                            <div class="col-12">
                                <iframe width="100%" height="400px" frameBorder="0" [src]="urlSafe" scrolling="no" frameborder="3"></iframe>
                            </div>
                            </div> 
                            <li class="mt-2">Once Java and Qz-Tray are installed, then follow the below steps to activate Qz-Tray.</li>

                            <div class="col-8 mt-1 ps-4">
                                <ul class="qz-inner-text">

                                    <li
                                        *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform != 'Mac68K' && this.isSystemplatform != 'MacIntel'))">
                                        Download and install the latest version of QZ-Tray.</li>

                                    <li
                                        *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))">
                                        Once installed, launch QZ-Tray from your system.</li>

                                    <li
                                        *ngIf="(this.isSystemplatform && (this.isSystemplatform == 'MacPPC' ||  this.isSystemplatform == 'Mac68K' || this.isSystemplatform == 'MacIntel'))">
                                        Right-click the QZ-Tray icon in the system tray (bottom-right corner of your screen).</li>

                                    <li
                                        *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))">
                                        Check the 'Automatically start' option.</li>

                                    <li>Close all browser windows and re-launch the application to apply changes.</li>
                                    
                                </ul>
                            </div>-->
                
                    <div class="col-4">
                        <img *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))"
                            id="activateImage" [src]="'assets/Qz_active_steps.png'">
                        <img *ngIf="(this.isSystemplatform && (this.isSystemplatform == 'MacPPC' ||  this.isSystemplatform == 'Mac68K' || this.isSystemplatform == 'MacIntel'))"
                            id="activateImage3" [src]="'assets/Mac_QZ_Tray.png'">
                        <img id="activateImage2" [src]="'assets/Qz-tray_action.png'">
                    </div>
                </div>
            </div>
        </div>
        <div class="row qz-steps" *ngIf="!isQzLatestInstalled">
            <div class="col px-4 pt-3 ms-2">
                <div class="row mb-1">
                    <div class="col-11 warning-qz-try">
                        <span class="qz-up-icon" *ngIf="!isDownloading && !downloadComplete"><img src="assets/img/QZ-tray.svg"></span>
                        <span class="m-0 ps-0 qz-up-icon-green" *ngIf="isDownloading"><i class="fa-regular fa-arrows-rotate"></i></span>
                        <span class="m-0 ps-0 qz-up-icon-green" *ngIf="downloadComplete && !isDownloading"><i class="fa-regular fa-circle-check"></i></span>
                        <h4 class="m-0 ps-2" *ngIf="isDownloading">Downloading Update</h4>
                        <h4 class="m-0 ps-2" *ngIf="!isDownloading && !downloadComplete">QZ Tray Update Available</h4>
                        <h4 class="m-0 ps-2" *ngIf="downloadComplete && !isDownloading">Download Complete</h4>
                    </div>
                    <div class="col-1 text-end">
                        <!--<app-user-guide-icon [ActiveTabId]= "'QzTrayInstallation'"></app-user-guide-icon>-->
                    </div>
                </div>

                <!-- Auto-Update Options Panel -->
                <div class="col pt-0 px-0"> 
                    <div class="card-body py-0">
                        <a #QzDownloadLink class="d-none" [href]="qzUrlString">Click Here</a>
                        
                        <!-- Show message before download -->
                        <div class="row mb-0 ms-0" *ngIf="!isDownloading && !downloadComplete">
                            <div class="col-1">

                            </div>
                            <div class="col-11 mb-0 ps-0 qz-try-body"> 
                                <p class="qz-pop">A new version (V26) of QZ Tray is available to enhance label printing performance and stability.</p>
                                <p class="qz-pop">To ensure a smooth printing experience, please follow the below steps:</p>
                                <ul class="mt-2 ms-4 mb-0">
                                    <li>Click the Update Now button to download the latest version of QZ Tray.</li>
                                    <li>Open the downloaded file (from your Downloads folder or the browser download bar) and click to complete the installation.</li>
                                    <li>Once installed, Log out and log back into the application.</li>
                                </ul>
                            </div> 
                        </div>
                        
                        <!-- Show progress bar during download -->
                        <div class="row mb-3" *ngIf="isDownloading">
                            <div class="qz-up-icon-green"></div><div class="col mb-4 qz-up-icon_green">This will only take a moment...</div>
                        </div>
                        <div class="row mb-3" *ngIf="isDownloading"> 
                            <div class="col mb-2">
                                <div class="progress" style="height: 10px;">
                                    <div class="progress-bar bg-success" 
                                         role="progressbar" 
                                         [style.width.%]="downloadProgress" 
                                         [attr.aria-valuenow]="downloadProgress" 
                                         aria-valuemin="0" 
                                         aria-valuemax="100">
                                        {{downloadProgress}}%
                                    </div>
                                </div>
                            </div> 
                        </div>
                        <div class="row" *ngIf="isDownloading"><div class="col mt-1 text-end"> {{downloadProgress}}%</div></div> 
                        <!-- Show completion message after download -->
                        <div class="row mt-3 mb-0" *ngIf="downloadComplete && !isDownloading">
                            <p class="col mb-2">
                                The latest version of QZ Tray has been downloaded successfully. Please install it and re-log in to complete the process.
                            </p>
                        </div>
                    </div>
                </div>

                <!-- Installation Instructions -->
                <li *ngIf="isQzLatestInstalled">After downloading the update, follow these steps to complete installation:</li>
                <div class="row" *ngIf="isQzLatestInstalled">
                    <div class="col-8">
                        <ul>

                            <li>Please start Qz-Tray from your Windows start Menu.</li>

                            <li
                                *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))">
                                Right click on the Qz-Tray box icon that is displayed towards the bottom right corner of
                                the Toolbar.</li>

                            <li
                                *ngIf="(this.isSystemplatform && (this.isSystemplatform == 'MacPPC' ||  this.isSystemplatform == 'Mac68K' || this.isSystemplatform == 'MacIntel'))">
                                Once Qz-Tray is Installed, then an active Qz-Tray (Green Box) appears at the bottom of
                                the screen as in the screen shot here.</li>

                            <li
                                *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))">
                                Check the 'Automatically start' option.</li>

                            <li>Close all Browser windows and Re-Launch the application to reflect the Qz-Tray Installation changes.</li>

                            <li class="margin_top_10rem">Now, when printing a label for the first time after
                                installation, a prompt will be displayed to allow to print.
                                On this, Check the 'Remember Me' option and click OK, to avoid redisplay of this pop-up.
                            </li>
                        </ul>
                    </div>
                    <div class="col-4">
                        <img *ngIf="(this.isSystemplatform && (this.isSystemplatform !== 'MacPPC' && this.isSystemplatform !== 'Mac68K' && this.isSystemplatform !== 'MacIntel'))"
                            id="activateImage" [src]="'assets/Qz_active_steps.png'">
                        <img *ngIf="(this.isSystemplatform && (this.isSystemplatform == 'MacPPC' ||  this.isSystemplatform == 'Mac68K' || this.isSystemplatform == 'MacIntel'))"
                            id="activateImage3" [src]="'assets/Mac_QZ_Tray.png'">
                        <img id="activateImage2" [src]="'assets/Qz-tray_action.png'">
                    </div>
                </div>
            </div>
        </div>
    </span> 
    <button *ngIf="!isQzLatestInstalled && !downloadComplete"  
            footer 
            autofocus 
            class="hotkey_primary update-now-btn qzTry-update-now-btn" 
            appShortcutKey 
            (click)="downloadAndInstallNow('FrmUpdate')"
            [disabled]="isDownloading">Update Now</button>
    <button *ngIf="!isQzLatestInstalled && downloadComplete" 
            footer 
            autofocus 
            class="hotkey_primary update-now-btn qzTry-update-now-btn" 
            appShortcutKey 
            (click)="logout()">Re-Login</button>
    <button *ngIf="isQzLatestInstalled" footer autofocus class="hotkey_primary" appShortcutKey InputKey="c" (click)="Cancel()"><b>C</b> Close
    </button>
    <div footer *ngIf="isQzLatestInstalled && isDownloading && fromMainScreen" style="cursor: move; user-select: none; width: 100%;">  
            <div class="w-100">
                <div class="progress" style="height: 10px;">
                    <div class="progress-bar bg-success"
                        role="progressbar"
                        [style.width.%]="downloadProgress"
                        [attr.aria-valuenow]="downloadProgress"
                        aria-valuemin="0"
                        aria-valuemax="100">
                    {{ downloadProgress }}%
                    </div>
                </div>
            </div> 
    </div>
</app-custom-modal>